import styles from './printablescorecard.module.css';
import constants from '../../../constants';

// How many rounds go on a single printed page. The grid in the CSS
// divides the page height evenly by however many rounds are on that
// page, so this stays correct even for a partial last page (e.g. 2
// overtime rounds).
const ROUNDS_PER_PAGE = 4;

function chunkRounds(rounds, size) {
  const pages = [];
  for (let i = 0; i < rounds.length; i += size) {
    pages.push(rounds.slice(i, i + size));
  }
  return pages;
}

// rounds, homeTeam, awayTeam, getPlayerName, constants: same values
// already in scope in the interactive Scorecard component.
// matchTitle (optional): e.g. `${awayTeam.name} @ ${homeTeam.name}` —
// shown once at the top of each printed page.
export default function PrintableScorecard({ rounds, homeTeam, awayTeam, getPlayerName, matchTitle }) {
  const pages = chunkRounds(rounds, ROUNDS_PER_PAGE);

  return (
    <div className={`${styles.PrintRoot} printable-sheet`}>
      {pages.map((pageRounds, pageIndex) => (
        <div className={styles.Page} key={pageIndex}>
          {matchTitle && <div className={styles.PageHeader}>{matchTitle}</div>}

          <div className={styles.RoundGrid} style={{ '--round-count': ROUNDS_PER_PAGE }}>
            {pageRounds.map((round, i) => {
              const roundNumber = pageIndex * ROUNDS_PER_PAGE + i;
              const roundLabel = roundNumber >= 8
                ? 'Overtime!'
                : `Round ${roundNumber + 1} ${round[0][constants.matchType] === constants.mixed ? 'Mixed' : 'Gendered'} Doubles`;

              return (
                <div className={styles.PrintRound} key={`${round[0][constants.matchupId]}-${round[0][constants.id]}`}>
                  <div className={styles.PrintRoundTitle}>{roundLabel}</div>

                  <div className={styles.PrintGameRow} style={{ '--game-count': round.length }}>
                    {round.map((game) => (
                      <div className={styles.PrintGame} key={`${game[constants.matchupId]}-${game[constants.gameNumber]}`}>
                        <div className={styles.AwayName}>{awayTeam.name}</div>
                        <div className={styles.HomeName}>{homeTeam.name}</div>

                        <div className={styles.AwayPlayers}>
                          <div>{game[constants.awayPlayer1] ? getPlayerName(game[constants.awayPlayer1]) : 'Player 1'}</div>
                          <div>&</div>
                          <div>{game[constants.awayPlayer2] ? getPlayerName(game[constants.awayPlayer2]) : 'Player 2'}</div>
                        </div>
                        <div className={styles.Vs}>VS</div>
                        <div className={styles.HomePlayers}>
                          <div>{game[constants.homePlayer1] ? getPlayerName(game[constants.homePlayer1]) : 'Player 1'}</div>
                          <div>&</div>
                          <div>{game[constants.homePlayer2] ? getPlayerName(game[constants.homePlayer2]) : 'Player 2'}</div>
                        </div>

                        <div className={styles.AwayScore}>{game[constants.awayScore] ?? ''}</div>
                        <div className={styles.Dash}>—</div>
                        <div className={styles.HomeScore}>{game[constants.homeScore] ?? ''}</div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}